import enGB from './en_gb.json'
import enCA from './en_ca.json'
import enUS from './en_us.json'
import frCA from './fr_ca.json'

const messages = {
  "en_us": {
    message: enUS
  },
  "en_gb": {
    message: enGB,
  },
  'en_ca': {
    message: enCA
  },
  "fr_ca" : {
    message: frCA
  }
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n/index.js